import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useGlobal } from '../../contexts/global';
import logoOlivasDigital from '../../assets/images/logo_olivas_digital.png';

const Footer = ({ cidade }) => {
  const { setShowRegulamento } = useGlobal();
  const { footer } = cidade;

  return (
    <section className="in-footer">
      <div className="in-footer-ctn">
        <div className="in-footer-ctn-grid">
          <p>
            {footer.copyright}
            {' - '}
            <Link to={`${cidade.pagina}/lgpd`}>
              Política de privacidade
            </Link> |{' '}
            <Link to={`${cidade.pagina}/termos-de-uso`}>Termos de uso</Link> |{' '}
            <span
              onClick={() => setShowRegulamento(true)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter') setShowRegulamento(true);
              }}
            >
              Regulamento
            </span>
          </p>
          <a
            href="https://www.olivas.digital/"
            rel="noreferrer"
            target="_blank"
          >
            <img src={logoOlivasDigital} alt="Olivas Digital" />
          </a>
        </div>
      </div>
    </section>
  );
};

Footer.propTypes = {
  cidade: PropTypes.shape({
    pagina: PropTypes.string.isRequired,
    footer: PropTypes.shape({
      copyright: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default Footer;
